<template>
  <div id="bdm_host_rank" :class="isFull === 1 ? 'bdm_host_rank top_information1' : ' bdm_host_rank'">
    <van-row>
      <van-col span="24" class="ranking_homepage_top_bg">
        <van-col span="24">
          <van-nav-bar
              :title="$t('column.host_ranking_month')"
              left-arrow
              placeholder
              fixed
              @click-left="onClickLeft"
          />
        </van-col>
        <van-col span="22" offset="1">
          <!-- Top 2 -->
          <van-col span="7" class="bdm_host_rank_number">
            <van-col span="22" offset="1" class="bdm_host_rank_number_bg">
              <img src="../assets/img/bdm/bdm_rank2.png" class="bdm_host_rank_number_img2"/>
              <van-image
                  width="13vw"
                  height="13vw"
                  round
                  class="bdm_host_rank_number_avatar"
                  fit="cover"
                  :src="list[1].head_image"
                  v-if="list.length > 1 && list[1].head_image"
              />
              <van-col span="24" class="top_badge_name_wrap" v-if="list.length > 1">
                <span class="top_badge_name">{{ list[1].nick_name }}</span>
                <img :src="list[1].sex === 1 ? sex1 : sex2" class="top_badge_sex"/>
                <img :src="require('../assets/img/level/wealth_level_'+ list[1].user_level +'.png')"  class="top_badge_level_icon"/>
                <img :src="require('../assets/img/level/charm_level_'+ list[1].charm_level +'.png')"  class="top_badge_level_icon"/>
              </van-col>
              <van-col span="24" class="top_badge_number_coin" v-if="list.length > 1">
                <span class="coin_text">{{ list[1].ticket }}</span>
                <img src="../assets/img/coin9.png" class="coin_img"/> 
              </van-col>
            </van-col>
          </van-col>

          <!-- Top 1 -->
          <van-col span="10" class="bdm_host_rank_number">
            <van-col span="18" offset="3" class="bdm_host_rank_number_bg">
              <img src="../assets/img/bdm/bdm_rank1.png" class="bdm_host_rank_number_img"/>
              <van-image
                  width="15vw"
                  height="15vw"
                  round
                  class="bdm_host_rank_number_avatar1"
                  fit="cover"
                  :src="list[0].head_image"
                  v-if="list.length > 0 && list[0].head_image"
              />
              <van-col span="24" class="top_badge_name_wrap" v-if="list.length > 0">
                <span class="top_badge_name">{{ list[0].nick_name }}</span>
                <img :src="list[0].sex === 1 ? sex1 : sex2" class="top_badge_sex"/>
               <img :src="require('../assets/img/level/wealth_level_'+ list[0].user_level +'.png')"  class="top_badge_level_icon"/>
                <img :src="require('../assets/img/level/charm_level_'+ list[0].charm_level +'.png')"  class="top_badge_level_icon"/>
              </van-col>
              <van-col span="24" class="top_badge_number_coin" v-if="list.length > 0">
                <span class="coin_text">{{ list[0].ticket }}</span>
                <img src="../assets/img/coin9.png" class="coin_img"/> 
              </van-col>
            </van-col>
          </van-col>

          <!-- Top 3 -->
          <van-col span="7" class="bdm_host_rank_number">
            <van-col span="22" offset="1" class="bdm_host_rank_number_bg">
              <img src="../assets/img/bdm/bdm_rank3.png" class="bdm_host_rank_number_img2"/>
              <van-image
                  width="13vw"
                  height="13vw"
                  round
                  class="bdm_host_rank_number_avatar"
                  fit="cover"
                  :src="list[2].head_image"
                  v-if="list.length > 2 && list[2].head_image"
              />
              <van-col span="24" class="top_badge_name_wrap" v-if="list.length > 2">
                <span class="top_badge_name">{{ list[2].nick_name }}</span>
                <img :src="list[2].sex === 1 ? sex1 : sex2" class="top_badge_sex"/>
                <img :src="require('../assets/img/level/wealth_level_'+ list[2].user_level +'.png')"  class="top_badge_level_icon"/>
                <img :src="require('../assets/img/level/charm_level_'+ list[2].charm_level +'.png')"  class="top_badge_level_icon"/>
              </van-col>
              <van-col span="24" class="top_badge_number_coin" v-if="list.length > 2">
                <span class="coin_text">{{ list[2].ticket }}</span>
                <img src="../assets/img/coin9.png" class="coin_img"/> 
              </van-col>
            </van-col>
          </van-col>
        </van-col>
      </van-col>

      <!-- List -->
      <van-col span="24" class="ranking_list_container">
        <van-list>
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2" class="ranking_list_cell">
            <van-col span="24" class="bdm_host_rank_item">
              <van-col span="3" class="ranking_list_item_number">{{ i + 1 }}</van-col>
              <van-col span="4" class="ranking_list_item_avatar">
                <van-image
                    width="12vw"
                    height="12vw"
                    round
                    :src="item.head_image"
                    fit="cover"
                />
              </van-col>
              <van-col span="10" class="ranking_list_item_info">
                <van-col span="24" class="ranking_list_item_user_name">
                   <img :src="item.country_img" class="flag_img" v-if="item.country_img"/>
                    <span class="name_text">{{ item.nick_name }}</span>
                     <img :src="item.sex === 1 ? sex1 : sex2" class="list_sex_icon"/>
                </van-col>
                <van-col span="24" class="ranking_list_item_user_level">
                  <img :src="require('../assets/img/level/wealth_level_'+ item.user_level +'.png')"  class="list_level_icon"/>
                  <img :src="require('../assets/img/level/charm_level_'+ item.charm_level +'.png')"  class="list_level_icon2"/>
                </van-col>
              </van-col>
              <van-col span="7" class="ranking_list_item_coin">
                <span class="coin_text_list">{{ item.ticket }}</span> <img src="../assets/img/coin9.png" class="list_coin_img"/>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from 'axios'

export default {
  data() {
    return {
      sex1: require('../assets/img/sex1.png'), // Male icon (blue)
      sex2: require('../assets/img/sex2.png'), // Female icon (pink)
      list: [],
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    get_list(){
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=agc_rank",{ params:{ token: token }}).then(res =>{
            console.log(res.data)
            if(res.data.status===1){
                this.list = res.data.data.list
            }
        })
    },
    onClickLeft() {
        this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/bdm_host_rank.vue